/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import ProductSvg from '../../../public/myproducts.svg';
import DetailSvg from '../../../public/mydetail.svg';
import EventsSvg from '../../../public/totalevents.svg';
import australiaflag from '../../../public/australiaflag.svg';
import SchemeService from '../../../services/SchemeService';
import drprocoSvg from '../../../public/prodr.svg';
import { showLoading } from 'react-global-loading';
import EventService from '../../../services/EventService';
import ProductService from '../../../services/ProductService';
import DocumentService from '../../../services/DocumentService';
import UserService from '../../../services/UserService';
import Notifications from '../../component/Notifications';
import Modal from 'react-modal';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class GlobalPractitionerDashboard extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    this.state = {
      expandSidebar: false,
      eventData: [],
      productsData: [],
      filteredEvents: [],
      filteredProducts: [],
      docsData: [],
      users: [],
      schemesData: {},
      eventPending: '',
      docApproved: '',
      docPending: '',
      eventApproved: '',
      productApproved: '',
      productPending: '',
      practitioner: [], page: 1, statusType: 1, showModal: false, modalData: {}
    };
  }

  componentDidMount = () => {

    this.getEventList(this.state.page, this.state.statusType);
    this.getProductList(this.state.page, this.state.statusType);
    this.getAllDocuments(this.state.page, this.state.statusType);
    this.getAllSchemes(this.state.page, this.state.statusType);
    this.getAllPractitioners();
    // this.getNotifications();

  };

  // getNotifications = () => {
  //   UserService.getNotifications()
  //     .then((result) => {
  //       if (!result) return;
  //       this.setState({ notiData: result.data });
  //       showLoading(false);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // }

  getAllDocuments = (page, status) => {
    showLoading(true);
    DocumentService.getAllDocuments({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) return;
        this.setState({ docsData: result });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getAllPractitioners = () => {
    UserService.getUsersList({ 'role': "Practitioners" })
      .then((result) => {
        if (!result) return;

        this.setState({
          practitioner: result
        });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };


  getAllSchemes = (pae, status) => {
    SchemeService.getAllSchemes()
      .then((result) => {
        if (!result) return;

        this.setState({ schemesData: result });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getEventList = (page, status) => {
    EventService.getAllEvents({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) {
          return;
        }
        showLoading(true);
        this.setState({ eventData: result });
        showLoading(false);

      })
      .catch((err) => {
        console.error(err);
      });
  };

  getProductList = (page, status) => {
    ProductService.fetchAllProducts({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ productsData: result });

        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  onNotiClick = (noti) => {
    // UserService.updateNoti({ 'id': noti.id })
    //   .then((result) => {
    //     if (!result) return;


    switch (noti.type) {
      case 'event':
        this.props.history.push({

          pathname: "/mission-event-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'product':
        this.props.history.push({

          pathname: "/mission-products-detail",
          search: `?id=${noti.post_id}`

        })
        break;
      case 'document':
        this.setState({ showModal: true })
        // this.state.docsData.data.filter(item => item.ID === noti.post_id).map(selectedData => (
        this.setState({ modalData: noti })
        // ));
        break;
      case 'scheme':
        this.setState({ showModal: true, modalData: noti })
        break;

    }
    // })
    // .catch((err) => {
    //   console.error(err);
    // });
  }
  render() {
    const { notiData, schemesData, practitioner, productsData, eventData, docsData, showModal, modalData } = this.state;
    return (
      <div className="container pt-2">
        {/* <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active " aria-current="page">Ayush Global Mission Dashboard</li>
          </ol>
        </nav> */}
        <div className="row p-2 mt-5 mb-3 rounded rounded-2 msnhead">
          <div className="col-md-2 d-flex align-items-center justify-content-center">
            <img src={userData.user_img} alt="australia flag" className="flagimg" />
          </div>
          <div className="col-md-10 head-title d-flex align-items-center m-textadjust">
            <h4><span className="agphdn t0">Ayush Global in {userData.blog_id?.blogname}</span></h4>
          </div>
        </div>
        <div className="row mt-5 mb-3 contrast-ration-sol">
          <div className="col-md-4 mb-3">
            <div className="card card-ico">
              <div className="card-body ">
                <h5 className="card-title fs-5 fw-bold t1">Practitioners <img src={ProductSvg} className="float-end" alt="my events" /></h5>
                <span className="badge t2 rounded rounded-3 text-bg-light w-100 align-middle p-2 mt-2 mb-2 countsct"><b className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{practitioner.length}</b>  </span>
                <div className="row mt-2 mb-2">
                  <div className="col-6">
                    <Link to="/practitioners-list" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      {/* <img src={ViewSvg} className="mx-1" alt="upload" /> */}
                      View
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link to="/add-my-practitioner-data" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                      {/* <img src={UpdateSvg} className="mx-1" alt="view and edit" /> */}
                      Add
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="card card-ico">
              <div className="card-body ">
                <h5 className="card-title fs-5 fw-bold t1">  Products  <img src={DetailSvg} className="float-end" alt="my events" /></h5>
                <span className="badge t2 rounded rounded-3 text-bg-light w-100 align-middle p-2 mt-2 mb-2  countsct"><b className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{productsData.total}</b> </span>
                <div className="row mt-2 mb-2">
                  <div className="col-6">
                    <Link to="/mission-all-products" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      {/* <img src={ViewSvg} className="mx-1" alt="edit"/>  */}
                      View
                    </Link>
                  </div>
                  <div className="col-6">
                    <a href="/add-mission-products" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                      {/* <img src={EditSvg} className="mx-1" alt="edit center"/>  */}
                      Add
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="card card-ico">
              <div className="card-body ">
                <h5 className="card-title fs-5 fw-bold t1">  Events <img src={EventsSvg} className="float-end" alt="my all events" /></h5>
                <span className="badge t2 rounded rounded-3 text-bg-light w-100 align-middle p-2 mt-2 mb-2  countsct"><b className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{eventData.total}</b>  </span>
                <div className="row mt-2 mb-2">
                  <div className="col-6">
                    <Link to='/mission-events' className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      {/* <img src={ViewSvg} className="mx-1" alt="add center" />  */}
                      View
                    </Link>
                  </div>
                  <div className="col-6">
                    <Link to='/mission/create-event' className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                      {/* <img src={AddSvg} className="mx-1" alt="view and edit center" />  */}
                      Add
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="card card-ico">
              <div className="card-body ">
                <h5 className="card-title fs-5 fw-bold t1">  Documents  <img src={DetailSvg} className="float-end" alt="my events" /></h5>
                <span className="badge t2 rounded rounded-3 text-bg-light w-100 align-middle p-2 mt-2 mb-2  countsct"><b className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle">{docsData.total}</b>  </span>
                <div className="row mt-2 mb-2">
                  <div className="col-6">
                    <a href="/mission-documents" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      {/* <img src={Edit3Svg} className="mx-1" alt="edit" />  */}
                      View
                    </a>
                  </div>
                  <div className="col-6">
                    <a href="/add-mission-documents" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                      {/* <img src={View3Svg} className="mx-1" alt="edit center" />  */}
                      Add

                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="card card-ico">
              <div className="card-body ">
                <h5 className="card-title fs-5 fw-bold t1">Schemes   <img src={EventsSvg} className="float-end" alt="my events" /></h5>
                <span className="badge t2 rounded rounded-3 text-bg-light w-100 align-middle p-2 mt-2 mb-2  countsct"><b className="text-primary-emphasis fs-2 fw-bold mx-3 align-middle"> {schemesData.total}</b>  </span>
                <div className="row mt-2 mb-2">
                  <div className="col-6">
                    <Link to="/mission-all-schemes" className="card-link rounded rounded-2 w-100 btntxdsh lightbtn t3">
                      {/* <img src={Add3Svg} className="mx-1" alt="add center" />  */}
                      View
                    </Link>
                  </div>
                  <div className="col-6">
                    <a href="/mission/add-scheme" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn t3">
                      {/* <img src={View3Svg} className="mx-1" alt="view and edit center" />  */}
                      Add
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Notifications />
      </div >

    );
  }
}

export default GlobalPractitionerDashboard;
